import {createSelector} from 'reselect';
import {RootState} from '../../rootReducer';
import {notificationsAdapter} from './adapters';
import {filterUnreadNotifications} from './utils';

export const getInstallation = (state: RootState) => state.data.notification.installation;

export const getIsPushNotificationEnabled = (state: RootState) =>
  state.data.notification.preferences.Updates.PushNotification;

export const getIsEmailNotificationEnabled = (state: RootState) =>
  state.data.notification.preferences.Updates.UserEmail;

export const getNotificationPreferencesLoadingStatus = (state: RootState) =>
  state.data.notification.preferencesLoadingStatus;

export const getIsUpdatingNotificationPreferences = (state: RootState) => state.data.notification.isUpdatingPreferences;

export const {
  selectById: getNotificationById,
  selectIds: getNotificationIds,
  selectEntities: getNotificationEntities,
  selectAll: getAllNotifications,
  selectTotal: getTotalNotifications,
} = notificationsAdapter.getSelectors((state: RootState) => state.data.notification.allNotifications);

export const getNotificationsLoadingStatus = (state: RootState) =>
  state.data.notification.allNotificationsLoadingStatus;

export const getCanDisplayEmptyNotifications = (state: RootState) =>
  state.data.notification.canDisplayEmptyNotifications;

export const getUnreadNotifications = createSelector(getAllNotifications, filterUnreadNotifications);

export const getInAppBadgeNumber = (state: RootState) => state.data.notification.inAppBadgeNumber;

export const getIsNotificationDeleting = (state: RootState, notificationId: string) =>
  state.data.notification.allNotifications.entities[notificationId].isDeleting;

export const getNotificationCategoryData = (state: RootState) => state.data.notification.categoryData;

export const getNotificationPreferences = (state: RootState) => state.data.notification.preferences;
